import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GetUserByID from "../../../Controllers/Auth/GetUserByID";

export const UserProfileViewModel = () => {
  const location = useLocation();
  const [UserData, setUserData] = useState({});
  const [UserID, setUserID] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [IsLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setUserID(LocationArray.pop());
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const UserObject = await GetUserByID(UserID);
      setUserData(UserObject);
      setIsLoading(false);
    }
    fetchData();
  }, [UserID]);

  console.log("UserData", UserData);

  useEffect(() => {
    const ArrayOfWords = UserData?.AdditionalDetails?.SchoolName?.split(" ");

    for (var i = 0; i < ArrayOfWords?.length; i++) {
      ArrayOfWords[i] =
        ArrayOfWords[i]?.charAt(0)?.toUpperCase() + ArrayOfWords[i]?.slice(1);
    }
    const StringOfWords = ArrayOfWords?.join(" ");
    setSchoolName(StringOfWords);
  }, [UserData?.AdditionalDetails?.SchoolName]);

  return { UserData, SchoolName, IsLoading };
};
